enum GenderWeight {
	"M" = 0,
	"F" = 40,
}

export default GenderWeight;
